import { render, staticRenderFns } from "./tablaTienda.vue?vue&type=template&id=1ae3eb87&scoped=true&"
import script from "./tablaTienda.vue?vue&type=script&lang=js&"
export * from "./tablaTienda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae3eb87",
  null
  
)

export default component.exports